import { getArrayOfMonths } from 'Helpers/DateHelpers'
import { setCapitalLetter } from 'Helpers/StringHelpers'
import { Select } from 'antd'
import { PropsWithChildren } from 'react'

interface ISelectMonthProps {
  month: number
  onChange: (value: number) => void
  style?: React.CSSProperties
}

/**
 * Render a combo with all the months of the year.
 * Pass the selected index month inside the props.
 * The months starts from 1.
 * @returns
 */
export default function SelectMonth({ month, onChange, style }: PropsWithChildren<ISelectMonthProps>) {
  const monthOptions = getArrayOfMonths().map((month, index) => (
    //From 1 to 12.
    <Select.Option key={++index} value={++index}>
      {setCapitalLetter(month)}
    </Select.Option>
  ))
  return (
    <Select style={style} value={month} onChange={onChange}>
      {monthOptions}
    </Select>
  )
}
